import React from 'react'
import Link from 'next/link'
import styled from 'styled-components'
import { PLANNING_LINKS } from '../../lib/guide-presentation.mjs'
import { analyticsModuleAttributes } from '../../lib/analytics-content.mjs'
import { colors } from '../../styles/base/_allBase.styles'
const Wrap = styled.section`
  width:min(118rem,calc(100% - 4rem)); margin:0 auto; padding:4rem 0;
  h2 { font:700 clamp(2.6rem,3vw,3.6rem)/1.2 'Whyte-Bold',sans-serif; margin:0 0 1rem; color:${colors.warmPalette.primaryDark}; }
  > p { max-width:65ch; font-size:1.8rem; margin:0 0 2.4rem; }
`
const Links = styled.div`
  display:grid; grid-template-columns:repeat(3,minmax(0,1fr)); gap:1.6rem;
  a { padding:1.8rem 2rem; background:white; border:1px solid ${colors.neutralPalette.greyLight}; border-radius:.6rem; }
  a:hover { border-color:${colors.warmPalette.primary}; }
  strong { display:block; font-size:1.9rem; color:${colors.warmPalette.primaryDark}; }
  span { display:block; margin-top:.4rem; font-size:1.6rem; }
  @media(max-width:767px) { grid-template-columns:repeat(2,minmax(0,1fr)); gap:1rem; a{padding:1.4rem;} }
  @media(max-width:359px) { grid-template-columns:1fr; }
`
export function GuidePlanning({ module }) {
  return <Wrap id="plan-your-visit" {...analyticsModuleAttributes({ _key: `${module?._key || 'home'}-planning` }, 'planning_links')}>
    <h2>Plan your visit</h2><p>The practical starting points for your time on Lombok’s south coast.</p>
    <Links>{PLANNING_LINKS.map(link => <Link key={link.id} href={link.href} data-analytics-cta-id={`${module?._key || 'home'}-${link.id}`} data-analytics-placement-id="home-planning"><strong>{link.label} <span aria-hidden="true" style={{display:'inline'}}>→</span></strong><span>{link.text}</span></Link>)}</Links>
  </Wrap>
}
export function LocalOverview({ module }) {
  return <Wrap {...analyticsModuleAttributes(module, 'local_overview')}>
    <h2>A base for exploring South Lombok</h2>
    <p>Selong Belanak sits on Lombok’s south coast, with a sweeping beach, surf schools and places to eat and stay in the surrounding villages. Spend time by the bay or explore the nearby beaches, then use our directories to compare your options.</p>
    <p>This local destination guide is operated by <a href="https://bonibeach.com" style={{textDecoration:'underline'}} data-analytics-cta-id="home-owner-boni" data-analytics-placement-id="home-overview">Boni Beach Lombok</a>. <Link href="/editorial-policy" style={{textDecoration:'underline'}}>Read our editorial policy.</Link></p>
  </Wrap>
}
